import React from "react";
import { Link } from "react-router-dom"; // ✅ IMPORTANT
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* Company Info */}
        <div className="footer-section">
          <h2>Doddamani TechDev Pvt Ltd</h2>
          <p>
            We provide Web Applications, Mobile Apps, Desktop Software,
            IoT Projects and Student Projects. Our services are available
            online and offline across state, national and international levels.
          </p>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3>Our Services</h3>
          <ul>
            <li>Web Application Development</li>
            <li>Mobile App Development</li>
            <li>Desktop Software</li>
            <li>IoT Projects</li>
            <li>Student Final Year Projects</li>
            <li>Software Training</li>
          </ul>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/products">Projects</Link></li>
            <li><Link to="/training">Training</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>📍 Karnataka, India</p>
          <p>📞 <a href="tel:+918884707098">+91 88847 07098</a></p>
          <p>✉ <a href="mailtovikasdoddamani@gmail.com">mailtovikasdoddamani@gmail.com</a></p>
        </div>

      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Doddamani TechDev Pvt Ltd. All Rights Reserved.
      </div>

    </footer>
  );
}

export default Footer;